module.exports = __webpack_public_path__ + "img/mrp_quote.62d51d7c.png";